const locale = {
    APPLICATIONS: "Мурожаатлар",
    TheRegistry: "Ёзув рўйхати",
    ThePatients: "Мижозлар",
    WaitingList: "Навбатдаги мижозлар",
    Telephony: "Қўнғироқлар",
    Doctors: "Ходимлар",
    WorkingHours: "Иш вақтлари",
    Access: "Кириш",
    Testimonials: "Шарҳлар",
    Services: "Хизматлар",
    Resources: "Ресурслар",
    EmailSMS: "Электрон почта ва СМС",
    AutoNotifications: "Автоматик хабарномалар",
    MailOut: "Почтага юбориш",
    Balance: "Баланс",
    MessageHistory: "Хабарлар тарихи",
    Analytics: "Маълумотлар таҳлили",
    GeneralAnalytics: "Умумий таҳлил",
    Employees: "Ходимлар",
    Employee: "Ходим",
    BlackBox: "Қора қути",
    MaterialAccounting: "Материаллар ҳисоби",
    Products: "Маҳсулотлар",
    OrderProducts: "Буюртмали маҳсулотлар",
    Categories: "Категориялар",
    Brands: "Брендлар",
    Suppliers: "Таъминотчи",
    FlowOfGoods: "Маҳсулотлар оқими",
    Storages: "Омборлар",
    Inventory: "Инвентаризация",
    Payroll: "Маошлар ҳисоби",
    SalarySettings: "Маош созламалари",
    OnlineBooking: "Онлайн бандлик",
    CompanysSettings: "Компания созламалари",
    Payment: "Тўлов",
    SignIn: "Кириш",
    SignedOut: "Чиқиш",
    UserName: "Фойдаланувчи номи",
    Password: "Парол",
    SignOut: "Чиқиш",
    Branch: "Филиал",
    Company: "Компания",
    Save: "Сақлаш",
    AboutCompany: "Компания ҳақида",
    TheTitleOfTheCompany: "Компания номи",
    BankingDetails: "Банк маълумотлари",
    EnterTheBankingDetails: "Банк маълумотларини киритинг",
    TheNameOfTheCompany: "Компания номи",
    Activity: "Фаолият тури",
    PhoneNumberOwners: "Телефон рақами",
    TheCompanysAddress: "Компания манзили",
    City: "Шаҳар",
    SessionHistoryRetentionPeriod: "Мурожаат тарихини сақлаш даври",
    SettingsAreSaved: "Созламалар сақланди",
    PhoneNumber: "Мобил телефон",
    EmailAddress: "Электрон почта манзили",
    CategoryPermission: "Рухсат тури",
    Function: "Амаллар",
    Jurnal: "Журнал",
    Online: "Онлайн",
    NewAdministrator: "Янги администратор",
    NewDoctor: "Янги доктор",
    SettingsProfile: "Созламалар профили",
    Name: "Исм",
    Surname: "Фамилия",
    EmailProgramAccess: "Электрон почта (Дастурга кириш)",
    Dostup: "Кириш",
    AvailableTimeForOnlineRegistration: "Онлайн рўйхат учун вақтлар",
    Phone: "Телефон",
    Access: "Кириш",
    Photo: "Расмлар",
    BeginningOfWork: "Иш бошланиши",
    January: "Январ",
    February: "Феврал",
    March: "Март",
    April: "Апрел",
    May: "Май",
    June: "Июн",
    July: "Июл",
    August: "Август",
    September: "Сентабр",
    October: "Октябр",
    November: "Ноябр",
    December: "Декабр",
    Monday: "Душанба",
    Tuesday: "Сешанба",
    Wednesday: "Чоршанба",
    Thursday: "Пайшанба",
    Friday: "Жума",
    Saturday: "Шанба",
    Sunday: "Якшанба",
    Mon: "ДУ",
    Tue: "СЕ",
    Wed: "ЧО",
    Thur: "ПА",
    Fri: "ЖУ",
    Sat: "ША",
    Sun: "ЯК",
    TODAY: "Бугун",
    Description: "Тавсиф",
    Patients: "Мижозлар",
    Birthday: "Туғилган кун",
    Gender: "Жинс",
    Discount: "Чегирма",
    EntriesInmonths53: "3 ойда 5+ ёзув",
    EntriesInmonths23: "3 ойда 2+ ёзув",
    HaventRegis3: "3 ойдан бери рўйхатдан ўтмаган",
    HaventRegis6: "6 ойдан бери рўйхатдан ўтмаган",
    NotReg: "Рўйхатдан ўтмаган",
    InTheLast30days: "Сўнгги 30 кун ичида",
    CantSignUpOnline: "Онлайн рўйхатдан ўтиш мумкин эмас",
    CanceledCO: "Бекор қилинган ташрифлар % бажарилганларидан кўп",
    Filtr: "Саралаш",
    MostActive: "Энг фаол мижозлар",
    Permanent: "Дўимий мижозлар",
    NotActive: "Фаол бўлмаган",
    Missing: "Йўқотилганлар",
    DidntVisit: "Ташриф буюрмаган",
    NewClients: "Янги мижозлар",
    BlackList: "Қора рўйхат",
    Problematic: "Муаммоли",
    AllInformation: "Барча маълумотлар",
    CardNumbers: "Карточка рақамлари",
    SurnameD: "Шариф",
    FamilyCard: "Оилавий карта",
    Boy: "Эркак",
    Girl: "Аёл",
    GenderSelect: "Жинсни танланг",
    Pasport: "Паспорт",
    TheNote: "Эслатма",
    LegalRepesentative: "Қонуний ваколатли",
    SocialNetwork: "Ижтимоий тармоқ",
    Address: "Манзил",
    LoyaltyPrograms: "Мижозларга кенгайтирилган дастурлар",
    Insurance: "Суғурта",
    Newsletters: "Янгиликлар",
    AutoNote: "Автоматик эслатма",
    NewClient: "Янги мижоз",
    Country: "Мамлакат",
    Region: "Вилоят",
    PersonalDiscount: "Шахсий чегирма",
    InsuranceCompany: "Суғурта компанияси",
    NumberPolice: "Полиc рақами",
    NewPatient: "Янги мижоз",
    English: "Ингилизча",
    Russian: "Русча",
    Uzbek: "Ўзбек",
    UzbekKril: "Ўзбек - Кирил",
    SelectABranch: "Филиал танланг",
    SearchClientServicesCreatingVisit: "Мижоз, хизматларни қидиринг, ташрифни яратинг",
    Partner: "Ҳамкор",
    AvailableTimeForOnlineRegistration: "Онлайн рўйхатга олиш учун мавжуд вақт",
    Specialization: "Мутасасислик",
    Short: "Оддий",
    Average: "Ўртача",
    Admin: "Ма'mур",
    DeleteEmploye: "Ишчи ўчирилсинми?",
    Delete: "Ўчириш",
    Cancel: "Бекор қилиш",
    SuccessfulSaved: "Муффақиятли сақланди",
    NameN: "Номи",
    NameProduct: "Товар номи",
    CodeProduct: "Товар коди",
    NominalVolume: "Номинал ҳажми",
    Remainder: "Қолган қисми",
    Reserve: "Резерв",
    Unit: "Ўлчов бирлиги",
    LowBalanceNotification: "Паст қолган миқдор огоҳлантириши",
    EnableWarehouseControl: "Омбор назоратини ёқиш",
    EnableRetailSales: "Савдони ёқиш",
    Brend: "Бренд",
    Brands: "Брендлар",
    Category: "Категория",
    NameCategory: "Категория номи",
    NewCategory: "Янги категория",
    EditCategory: "Категорияни таҳрирлаш",
    DeleteCategory: "Категорияни ўчириш?",
    SearchCategories: "Категорияларни қидириш",
    Seria: "Серия",
    Serias: "Серийлар",
    NameSeria: "Серия номи",
    NewSeria: "Янги серия",
    EditSeria: "Серияни таҳрирлаш",
    DeleteSeria: "Серийни ўчириш?",
    SearchSerias: "Серийларни қидириш",
    NameBrands: "Бренд номи",
    NewBrands: "Янги бренд",
    EditBrands: "Брендни таҳрирлаш",
    DeleteBrands: "Брендни ўчириш?",
    SearchBrands: "Брендларни қидириш",
    NameResources: "Ресурс номи",
    NewResources: "Янги ресурс",
    EditResources: "Ресурсни таҳрирлаш",
    DeleteResources: "Ресурсни ўчириш?",
    SearchResources: "Ресурсларни қидириш",
    NewProduct: "Янги товар",
    Invoice: "Ҳисоб-фактура",
    EditProduct: "Маҳсулотни таҳрирлаш",
    DeleteProduct: "Маҳсулотни ўчириш?",
    SearchProduct: "Маҳсулотларни қидириш",
    NameSuppliers: "Етказиб берувчи",
    Suppliers: "Етказиб берувчилар",
    NewSuppliers: "Янги етказиб берувчи",
    EditSuppliers: "Етказиб берувчини таҳрирлаш",
    DeleteSuppliers: "Етказиб берувчини ўчирасизми?",
    SearchSuppliers: "Етказиб берувчини қидириш",
    WebSite: "Веб-сайт",
    NameStoreHouses: "Омбор номи",
    NewStoreHouses: "Янги омбор",
    EditStoreHouses: "Омборни таҳрирлаш",
    DeleteStoreHouses: "Омборни ўчирасизми?",
    SearchStoreHouses: "Омборларни қидириш",
    RetailPrice: "Дўкон нархи",
    SupplierPrice: "Етказиб берувчи нархи",
    DownloadXLS: "XLS-ни юклаш",
    All: "Ҳаммаси",
    From: "Санадан:",
    To: "Санагача:",
    Operation: "Амалиёт",
    WorkingDays: "Иш кунлари:",
    WorkingHours: "Иш соатлари",
    HoursForServices: "Хизмат соатлари:",
    ServicesCarriedOut: "Бажарилган хизматлар:",
    AmountOfServices: "Хизматлар суммаси:",
    ProductsSold: "Сотилган товарлар:",
    AmountOfGoods: "Товар суммаси:",
    EmployeeIncome: "Ходим даромади:",
    CompanyRevenue: "Корхона даромади:",
    StartTime: "Бошланиш вақти",
    ServiceTime: "Хизмат вақти",
    Service: "Хизмат",
    OfTheService: "Хизматнинг %",
    Product: "Товар",
    OfTheProduct: "Товардын %",
    IncomeEmployees: "Ходимлар даромади",
    CompanyRevenue: "Корхона даромади",
    ServicesProvided: "Кўрсатилган хизматлар:",
    ItemsSold: "Сотилган махсулотлар:",
    SalarySettings: "Маош созламалари",
    SelectingABet: "Ставкани танлаш",
    MonthlySalary: "Ойлик иш ҳақи",
    GuaranteedSalary: "Кафолатланган маош",
    PercentageOnSales: "Сотувлар бўйича фоизлар",
    Rates: "Ставкалар",
    Hours: "Соатлар",
    EnterCategoryName: "Категория номини киритинг",
    ES1: "SMS огоҳлантиришлар",
    ES2: "(Огоҳлантиришлар ўчирилган. Етарли баланс йўқ)",
    ES3: "Автоматик огоҳлантиришлар (рўйхатдан ўтиш, ташриф эслатмалари, рўйхатдан ўчириш)",
    ES4: "Рўйхатдан ўтишда огоҳлантириш",
    ES5: "Ташриф ҳақида эслатма",
    ES6: "Ташриф эслатмалари интервали",
    ES7: "Кун олдин юборилган:",
    ES8: "SMS ва email баланс пастлиги ҳақида огоҳлантириш",
    ES9: "Мижозларни вақтда рўйхатдан ўтказиш зарур, чунки SMS эслатмалари тез-тез юборилади",
    ES10: "Email огоҳлантиришлар",
    ES11: "Автоматик огоҳлантиришлар (рўйхатдан ўтиш, ташриф эслатмалари)",
    ES12: "Ташрифни ўчириш огоҳлантиришлари",
    ES13: "Ташриф эслатмалари",
    ES14: "SMSдаги ташриф ҳаволаси",
    ES15: "SMSдаги хизмат номи",
    ES16: "Янги мижозларни тасдиқлаш",
    ES17: "SMS авто изоҳнома",
    ES18: "Email автоматик хабарнома",
    before: "Ўтган",
    TurnOff: "Ўчириш",
    EL1: "SMS тарқатиш",
    EL2: "SMS сони:",
    EL3: "Белгилар сони:",
    EL4: "Матн киритинг",
    EL5: "Қабул қилувчини танлаш",
    EL6: "Барча мижозлар",
    EL7: "Барча ходимлар",
    EL8: "Тарқатиш яратиш",
    EB1: "SMS сони:",
    EB2: "Email сони:",
    EB3: "Балансни тўлдириш",
    EH1: "Телефон рақамига",
    Text: "Матн",
    EH2: "SMS сони",
    EHNO: "Ресурслар - бу махсулотларни кўрсатишда ишлатиладиган воситалар. Уларни бир вақтнинг ўзида бир нечта ходим ишлатаолмайди. Ресурсни яратиб, керакли хизматларда фаоллаштиринг.",
    Resources: "Ресурслар",
    Date: "Сана",
    NewServices: "Янги хизматлар",
    DeleteGroups: "Хизмат гуруҳини ўчиришми?",
    DeleteGroupsInfo: "Бу ҳаракат гуруҳдаги ташрифларнинг ўчирилишини олиб келиши мумкин. Ташрифларни текширинг ва сақланг.",
    NewEntry: "Янги ёзув",
    Entry: "Ёзув",
    min: "дақиқа",
    Beginning: "Бошланиш",
    Duration: "Давомийлиги",
    OneTimeDiscount: "Бир марталик чегирма",
    Executor: "Бажарувчи",
    ActualPrice: "Ҳақиқий нарх",
    AddAService: "Хизмат қўшиш",
    AddHelpers: "Ёрдамчи қўшиш",
    AddingAPatient: "Мижоз қўшиш",
    Telefon: "Телефон",
    AllAmount: "Умумий нарх",
    Day: "Кун",
    Month: "Ой",
    Year: "Йил",
    Profile: "Профиль",
    VisitHistory: "Ташриф тарихи",
    MedCard: "Тиббиёт картаси",
    VisitAmount: "Ташрифлар сони",
    MiddleCheck: "Ўртача чек",
    Canceled: "Бекор қилинган",
    Done: "Бажарилди",
    VisitAll: "Жами ташрифлар",
    Price: "Нарх",
    MinimalBudget: "Минимал бюджет",
    FinanceAnal: "Молиявий таҳлил",
    TotalRecords: "Жами ёзувлар",
    OnlineRecords: "Онлайн ёзувлар",
    JurnalRecords: "Журнал ёзувлар",
    SinceYes: "кундан бошлаб",
    NewPatients: "Янги мижозлар",
    RegularPatients: "Доимий мижозлар",
    NoPatients: "Мижоз йўқ",
    PatientsNotCome: "Келмаган мижозлар",
    NotCatgoryService: "Агар категорияда хизматлар бўлса, уни ўчирмаслик керак.",
    NameService: "Хизмат номи",
    DetailsServices: "Хизмат тафсилотлари",
    SettingsService: "Хизмат созламалари",
    LocalCurrency: "Валютa",
    Amountto: "дан",
    AmountFrom: "гача",
    AmountService: "Хизмат нархи",
    Details: "Тафсилотлар",
    EditServices: "Хизматни таҳрирлаш",
    DeleteServices: "Хизматни ўчириш?",
    SearchServices: "Хизмат номини киритинг",
    Owner: "Эгаси",
    LichCalendar: "Шахсий тақвим",
    Shop: "Дўкон",
    stock: "Омбор",
    AddSales: "Янги сотув",
    HAddSR: "Махсулот импорти",
    Buyer: "Харидор",
    Back: "Орқага",
    Code: "Код",
    Status: "Ҳолат",
    OrderPrice: "Буюртма нархи",
    Instalment: "Оласилик",
    NameSubcategory: "Категория",
    NewSubcategory: "Янги қуйи категория",
    EditSubcategory: "Қуйи категорияни таҳрирлаш",
    DeleteSubcategory: "Қуйи категорияни ўчириш?",
    SearchSubcategories: "Қуйи категорияларни қидириш",
    Subcategories: "Қуйи категориялар",
    Subcategory: "Қуйи категория",
    Quantity: "Миқдор",
    Add: "Қўшиш",
    Repair: "Тамир",
    Order: "Буюртма",
    Nomenclature: "Номенклатура",
    Purchase: "Импорт",
    Sales: "Сотишлар",
    InterBranch: "Филиаллар ўртасида",
    NothingAdded: "Ҳеч нарса қўшилмаган",
    EditEntry: "Записьни таҳрирлаш",
    ClientWaiting: "Клиент кутяпти",
    ClientCome: "Клиент келди",
    ClientNo: "Клиент келмади",
    ClientSuccess: "Клиент тасдиқланди",
    Master: "Мутахассис",
    Edit: "Таҳрирлаш",
    DeleteEntry: "Записьни ўчириш",
    Directorys: "Рўйхатлар",
    Directory: "Каталог",
    NameDirectorys: "Каталог номи",
    NewDirectorys: "Янги каталог",
    EditDirectorys: "Каталогни таҳрирлаш",
    DeleteDirectorys: "Каталогни ўчириш",
    SearchDirectorys: "Каталогларни қидириш",
    MatrialTypes: "Матриял турлари",
    MatrialType: "Матриял тури",
    NameMatrialTypes: "Матриял тури номи",
    NewMatrialTypes: "Янги матриял тури",
    EditMatrialTypes: "Матриял турини таҳрирлаш",
    DeleteMatrialTypes: "Матриял турини ўчириш",
    SearchMatrialTypes: "Матриял турларини қидириш",
    ExecutorType: "Ижро тури",
    NameExecutorTypes: "Ижро тури номи",
    NewExecutorTypes: "Янги ижро тури",
    EditExecutorTypes: "Ижро турини таҳрирлаш",
    DeleteExecutorTypes: "Ижро турини ўчириш",
    SearchExecutorTypes: "Ижро турларини қидириш",
    ColourType: "Ранг",
    NameColourTypes: "Ранг номи",
    NewColourTypes: "Янги ранг",
    EditColourTypes: "Рангни таҳрирлаш",
    DeleteColourTypes: "Рангни ўчириш",
    SearchColourTypes: "Рангларни қидириш",
    VentilationSize: "Вентиляция ҳажми",
    NameVentilationSizes: "Вентиляция ҳажми номи",
    NewVentilationSizes: "Янги вентиляция ҳажми",
    EditVentilationSizes: "Вентиляция ҳажмини таҳрирлаш",
    DeleteVentilationSizes: "Вентиляция ҳажмини ўчириш",
    SearchVentilationSizes: "Вентиляция ҳажмларини қидириш",
    Client: "Клиент",
    Report: "Ҳисобот",
    DebitOrderTransact: "Буюртма транзакциялари",
    DebitTotalTransact: "Жами сотувлар",
    DebitTransactSummary: "Маҳсулот ҳисоботи",
    ClientName: "Клиент исми",
    Fullname: "ФИО",
    VentilationType: "Ўлчов бирликлари",
    Measure: "Ўлчов",
    AutoSalary: "Автоматик маошлар",
    ProductsNo: "Маҳсулот йўқ",
    ProductsAdd: "Маҳсулот қўшиш",
    ListProducts: "Маҳсулотлар рўйхати",
    Amount: "Нархи",
    ProductsAmount: "Хизмат нархи",
    Waiting: "Кутилмоқда",
    RowsPerPage: "Саҳифадаги қаторлар",
    Consumptions: "Чиқимлар",
    Consumption: "Чиқим",
    NameConsumptions: "Чиқим номи",
    NewConsumptions: "Янги чиқим",
    EditConsumptions: "Чиқимни таҳрирлаш",
    DeleteConsumptions: "Чиқимни ўчириш",
    SearchConsumptions: "Чиқимларни қидириш",
    Success: "Муваффақиятли",
    Expectations: "Кутилмоқда",
    Vendor: "Сотувчи",
    RateAmount: "Чегирма нархи",
    Date: "Вақт",
    Reset: "Тозалаш",
    OptionType: "Вариант",
    NameOptionTypes: "Вариант номи",
    NewOptionTypes: "Янги вариант",
    EditOptionTypes: "Вариантни таҳрирлаш",
    DeleteOptionTypes: "Вариантни ўчириш",
    SearchOptionTypes: "Вариантларни қидириш",
    TypeType: "Тур",
    NameTypeTypes: "Тур номи",
    NewTypeTypes: "Янги тур",
    EditTypeTypes: "Турни таҳрирлаш",
    DeleteTypeTypes: "Турни ўчириш",
    SearchTypeTypes: "Турларни қидириш",
    SerialType: "Серия тури",
    NameSerialTypes: "Серия тури номи",
    NewSerialTypes: "Янги серия тури",
    EditSerialTypes: "Серия турини таҳрирлаш",
    DeleteSerialTypes: "Серия турини ўчириш",
    SearchSerialTypes: "Серия турларини қидириш",
    Request: "Сўровлар",
    AddRequest: "Сўров қўшиш",
    EnterProductName: "Маҳсулот номини киритинг",
    NotMandatory: "(Танлаш мажбурий эмас!)",
    Settings: "Созламалар",
    Today: "Бугун",
    Previous: "Аввалги",
    Next: "Кейинги",
    Wait: "Тасдиқланмаган",
    Paid: "Тўланган",
    Finance: "Молия",
    CASH: "Нақд",
    UZCARD: "Uzcard",
    HUMO: "Humo",
    TRANSFER: "Перечисления",
    CLICK: "Click",
    SERTIFICAT: "IHMA",
    UZUM_NASIYA: "Узум насия",
    Payments: "Тўловлар",
    Rollback: "Қайтарилди",
    ExpenseType: "Чиқим тури",
    NameExpenseTypes: "Чиқим тури номи",
    NewExpenseTypes: "Янги чиқим тури",
    EditExpenseTypes: "Чиқим турини таҳрирлаш",
    DeleteExpenseTypes: "Чиқим турини ўчириш",
    SearchExpenseTypes: "Чиқим турларини қидириш",
    AmountOfAcceptedOrders: "Қабул қилинган буюртмалар миқдори",
    TotalAmount: "Тўлов миқдори",
    CancelAmount: "Қайтарилган миқдори",
    ExpenseAmount: "Чиқим миқдори",
    Total: "Жами",
    Send: "Юбориш",
    Login: "Тизимга кириш",
    MY_PROFILE: "Менинг профилим",
    OldPassword: "Эски парол",
    NewPassword: "Янги парол",
    EditPassword: "Паролни ўзгартириш",
    ShortName: "Қисқа номи",
    Loading: "Юкланмоқда",
    AddFilial: "Филиал қўшиш",
    SaveFilial: "Сақлаш",
    RECEPTION: "Қабул",
    SearchPasient: "Клиентни қидириш",
    Indicator: "Кирим/Чиқим",
    EmployeeProductivity: "Ходимнинг самарадорлиги",
    VisitCount: "Ташрифлар сони",
    ClientCount: "Клиентлар сони",
    TopServices: "Оммавий хизматлар",
    WorkHourse: "Иш соатлари",
    VisitHourse: "Ташриф соатлари",
    EmptyHourse: "Бўш соатлар",
    New: "Янги",
    Ear_id: "Ўнг/Чап",
    document_number: "Ҳужжат рақами",
    shop_id: "Дўкон ID",
    serial_number: "Серия рақами",
    total_reverse_trans_amount: "Қайтарилган сумма",
    total_trans_amount: "Номенклатур суммаси",
    total_order_amount: "Буюртма суммаси",
    total_credit_amount: "Чиқим суммаси",
    FullOrderList: "Буюртмалар рўйхати",
    TotalTransactSummary: "Умумий ҳисобот",
    YearOfFilial: "Фаолияти бошланган йил",
    UnitPrice: "Дона нарх",
    NEACTIVE: "Фаол эмас",
    ACTIVE: "Фаол",
    SpecializationType: "Мутахассислик",
    NameSpecializationTypes: "Мутахассислик номи",
    NewSpecializationTypes: "Янги мутахассислик",
    EditSpecializationTypes: "Мутахассислик таҳрирлаш",
    DeleteSpecializationTypes: "Мутахассислик ўчириш",
    SearchSpecializationTypes: "Мутахассисликларни қидириш",
    PaymentHistory: "Тўлов тарихи",
    IsDeleteClientOrder: "Афсус, тўлов қилинганлиги сабабли ўчириб бўлмайди!",
    DocumentNumber: "Шартнома рақами",
    More: "Батафсил",
    Income: "Кирим",
    Rollback: "Қайтарилган",
    Debt: "Қарздорлик",
    Sold: "Сотилган",
    Repair: "Тамир",
    Labaratory: "Лаборатория",
    PHONE_NUMBER_DUBLICATE: "Ушбу рақам аввал рўйхатдан ўтган, илтимос телефон рақам ёки берилган исм фамилия бўйича қидиринг! <br>",
    DescLab: "Лаборатория тавсифи",
    Send: "Жўнатилди",
    Working: "Жараёнда",
    Acceptance: "Қабул",
    Ready: "Тайёр",
    IsDeleteClientOrderPOR: "Афсус, матриаллар қаторида махсулотлар, буюртмалар ёки тамир борлиги сабабли ёзувни ўчириб бўлмайди!",
    IsDeleteClientOrderSales: "Афсус, сотув бўлимида махсулотлар, буюртмалар ёки тамир борлиги сабабли ёзувни ўчириб бўлмайди!",
    NotDelete: "Ўчириб бўлмайди!",
    SalesHistory: "Сотувлар тарихи",
    SelectDate: "Сана танланг",
    ProductsType: "Маҳсулот тури",
    AllPrice: "Жами сумма",
    District: "Туман/Шаҳар",
    SearchSeria: "Серия қидириш",
    Search: "Қидириш",
    Sum: "сўм",
    CurrencyRate: "Валюта курси",
    CurrencyHistory: "Курс тарихи",
    date: "сана",
    AddServices: "Хизматларни қўшиш",
    HowDidYouHearAboutUs: "Хабардор бўлганлик",
    ForgotPassword: "  Паролни унутдингизми?",
    NewEmailPassword: "Ушбу emailга янги парол жўнатилди",
    Materilas: "Материаллар",
    ClientHistory: "Мижоз тарихи",
    ProductNumber: "Товар рақами",
    SorryNoProduct: "Афсус бундай товар топилмади",
    Found: "топилди",
    NoOrder: "Буюртма йўқ",
    AddOrder: "Буюртма қўшиш",
    Right: "Ўнг",
    Left: "Чап",
    OnsideColor: "Ташқи ранг",
    InColor: "Ички ранг",
    Size: "Ўлчами",
    UsedProducts: "Фойдаланилган махсулотлар",
    ProductHistory: "Маҳсулот тарихи",
    Too: "га",
    Fromm: "дан",
    SuccessfullyCompleted: "Мувофиқиятли якунладими",
    DoYouWantToReturnTheGoods: "Сиз товарни қайтармоқчимисиз?",
    YouAddedThisSeries: "Бундай серияни қўшгансиз",
    SeriaNumber: "Серия рақам",
    AvailableSerialNumbers: "Мавжуд Серия рақамлар",
    AvailableQuantity: "Мавжуд миқдор",
    FinishedProduct: "Тайёр маҳсулот",
    FinishedProductConfirmation: "Тайёр маҳсулотни тасдиқлаш",
    NotRefundable: "Қайтарилиши мумкин эмас",
    HearingAids: "Эшитиш воситалари",
    PersonalHearingAids: "Шахсий эшитиш воситалари",
    HearingAidParts: "Эшитиш воситалари учун қисмлар",
    OtherGoods: "Бошқа товарлар",
    Location: "Жойлашган жойи",
    NotificationAmount: "Хабар бериш миқдори",
    AvailableItems: "Товари мавжуд бўлганлари",
    Transactions: "Транзакциялар",
    NoProductToRepair: "Тамирланадиган маҳсулот йўқ",
    EnterOnlyLatinLetters: "Фақат лотин харфларини киритинг!",
    Remainder: "Қолдиқ",
    TotalCalculatedAmount: "Жами ҳисобланган миқдор",
    Conclusion: "Якунлаш",
    ThankYouLook: "Раҳмат! Яна кутамиз.",
    ProductsAboutInfo: "Маҳсулотлар ҳақида маълумот",
    ServicesAboutInfo: "Хизматлар ҳақида маълумот",
    Incomes: "Киримлар",
    AboutInfo: "ҳақида маълумот",
    ServiceWork: "Хизмат кўрсатиш",
    PaymentType: "Тўлов тури",
    User: "Фойдаланувчи",
    IncorrectUsernameOrPassword: "Фойдаланувчи номи ёки парол нотўғри",
    SendEmail: "emailга жўнатилди",
    PaidP: "Пуллик",
    Series: "Сериали",
    WithoutSeries: "Сериасиз",
    NotPaid: "Тўланмаган",
    CustomerMap: "Мижоз харитаси",
    AutomaticSalaryCalculation: "Маошни автоматик равишда ҳисоблаш",
    Salary: "Ойлик",
    Retail: "Чакана",
    EstimatedSalary: "Ҳисобланган маош",
    Bonus: "Бонус",
    Salaries: "Маошлар",
    YouHaveSignedOut: "Сиз тизимдан чиқдингиз!",

};

export default locale;
